import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=223abea1&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223abea1')) {
      api.createRecord('223abea1', component.options)
    } else {
      api.reload('223abea1', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=223abea1&", function () {
      api.rerender('223abea1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SideBar.vue"
export default component.exports